import { css } from '@emotion/css'
import { borderRadius, breakpoint, colors, fontSize, fontWeight, hexToRgba, mediaQueryHelper } from '@offerzen/pinata'

const styles = {
  filterBlock: css({
    display: 'flex',
    flexDirection: 'column',
    marginRight: 0,
    paddingBottom: 18,
    width: '100%',
    maxWidth: 'unset',

    [mediaQueryHelper(breakpoint.phone)]: {
      paddingBottom: 18,
      maxWidth: 'unset',
      flex: 'unset',
    },

    [mediaQueryHelper(breakpoint.tablet)]: {
      paddingBottom: 0,
      maxWidth: '200px',
      flex: 'unset',
      marginRight: 10,
    },
  }),

  label: css({
    fontWeight: fontWeight.regular,
    color: colors.white,
    fontSize: fontSize.default,
    display: 'block',
    marginBottom: 8,

    [mediaQueryHelper(breakpoint.tablet)]: {
      fontSize: fontSize.small,
      color: colors.scorpion,
    },
  }),

  error: css({
    fontWeight: fontWeight.regular,
    fontSize: fontSize.small,
    color: colors.redDamask,
  }),

  filterInputWrapper: css({
    position: 'relative',
    borderRadius: borderRadius.default,
    width: '100%',
    boxSizing: 'border-box',

    [mediaQueryHelper(breakpoint.phone)]: {
      marginBottom: 0,
    },

    '&:focus': {
      outline: 'none',
      backgroundColor: colors.porcelain,
    },

    '& ul': {
      border: `1px solid ${colors.mystic} !important`,
      borderRadius: borderRadius.medium,
      boxShadow: `0 2px 10px ${hexToRgba(colors.black, 0.07)} !important`,
    },

    '& >:first-child': {
      fontSize: 16,
      fontWeight: 600,
      color: colors.scorpion,
      border: 'none',
      [mediaQueryHelper(breakpoint.tablet)]: {
        border: 'inherit',
      },
    },

    '& >:first-child input': {
      height: '45px !important',
      backgroundColor: colors.white,
      border: `1px solid ${colors.grayChateau}`,
      width: '100%',
    },

    '& :focus-within': {
      backgroundColor: colors.white,
      [mediaQueryHelper(breakpoint.tablet)]: {
        backgroundColor: 'inherit',
      },
    },

    '& ul li': {
      fontWeight: fontWeight.regular,
    },

    '& >:first-child input::placeholder': {
      fontWeight: fontWeight.regular,
    },

    // Target element with border and height set
    '& div[role=combobox] >:first-child': {
      height: 45,
    },

    '& small': {
      paddingTop: 6,
      fontWeight: fontWeight.regular,
      color: colors.white,
      [mediaQueryHelper(breakpoint.tablet)]: {
        color: colors.redDamask,
      },
    },
  }),
}

export default styles
